import ReportComponent from "../components/Report";
import useReport from "../hooks/useReport";

const Report = () => {
    const reportProps = useReport();
    return <ReportComponent {...reportProps} />;
};

export default Report;
